const skillData = {
  General: {
    title: 'General',
    skills: [
      'Visual Design',
      'UX Design',
      'Responsive Design',
      'Design Principles',
      'Web Applications',
      'Branding',
      'Front-End',
    ],
  },
  Design: {
    title: 'Design',
    skills: ['Sketch', 'Invision'],
  },
  Engineering: {
    title: 'Engineering',
    skills: ['React.js', 'HTML5', 'CSS3', 'JSS', 'Javascript'],
  },
}

export default skillData
